import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import "./css/modal.scss";

interface IParams {
    confirmLabel?: string;
    content: ReactNode;
    displayCancel?: boolean;
    isModalOpen: boolean;
    targetId?: string | number;
    title: string;
    close(): void;
    confirm(id?: string | number): void;
}

export const Modal = (props: IParams) => {
    const { t } = useTranslation("common");
    const {
        content,
        isModalOpen,
        displayCancel = false,
        targetId,
        title,
        close,
        confirm,
        confirmLabel = t("confirm"),
    } = props;

    return (
        <Dialog fullWidth maxWidth="md" open={isModalOpen} onClose={close}>
            <Grid className="dialog-close" container justify="flex-end">
                <Grid className="dialog-close__icon" item>
                    <IconButton aria-label="close" onClick={close}>
                        <CloseIcon color="disabled" />
                    </IconButton>
                </Grid>
            </Grid>
            <DialogTitle disableTypography>
                <Grid container justify="center">
                    <Grid item sm={12} xs={6}>
                        <Typography align="center" color="secondary" variant="h3">
                            {title}
                        </Typography>
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent>
                <Typography align="center" variant="body1">
                    {content}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Grid container justify="center" spacing={2}>
                    {displayCancel && (
                        <Grid item md={2} sm={3} xs={6}>
                            <Button
                                className="xtest_modal_close_button"
                                fullWidth
                                size="large"
                                variant="contained"
                                onClick={close}
                            >
                                {t("cancel")}
                            </Button>
                        </Grid>
                    )}
                    <Grid item md={2} sm={3} xs={6}>
                        <Button
                            className="xtest_modal_confirm_button"
                            color="secondary"
                            fullWidth
                            size="large"
                            variant="contained"
                            onClick={() => confirm(targetId)}
                        >
                            {confirmLabel}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
};
